import { Text, TextStyle } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../../common/components/ButtonWithScaleAnimation";
import { GameFont } from "../../../common/GameFont";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class PurchaseBuildingButton extends ButtonWithScaleAnimation {
    private static readonly BUY_TEXT = "BUY FOR";

    private readonly marketPlaceButtonText: Text;
    private readonly costInUsdText: Text;

    public constructor(commonResources: CommonResourcesPackage, costInUsd: number) {
        super(commonResources.assets_common_ui_button_green_without_shadow_png);
        this.defaultView.width = 280;
        this.defaultView.height = 130;

        this.marketPlaceButtonText = new Text(PurchaseBuildingButton.BUY_TEXT, new SeeBuildingInButtonTextStyle());
        this.marketPlaceButtonText.position.set(this.width * 0.5 - this.marketPlaceButtonText.width * 0.5, 19.5);
        this.addChild(this.marketPlaceButtonText);

        this.costInUsdText = new Text(`$${costInUsd}`, new UsdTextStyle());
        this.costInUsdText.position.set(this.defaultView.width * 0.5 - this.costInUsdText.width * 0.5, 64);
        this.addChild(this.costInUsdText);
    }

    public setActive(value: boolean): void {
        this.visible = value;
        this.eventMode = value ? "static" : "none";
    }
}

class SeeBuildingInButtonTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 43.6,
            dropShadow: true,
            dropShadowColor: "#0d0606",
            dropShadowAlpha: 0.3,
            dropShadowAngle: 0.82859,
            dropShadowBlur: 5,
            dropShadowDistance: 1
        }));
    }
}

class UsdTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: "BebasNeue Regular",
            fontSize: 34.26,
            letterSpacing: 0,
            fontWeight: "400"
        }));
    }
}
